import type { ImeiHubServiceId } from '@redevicer/shared'

/** i18n keys for detail panel bullet lists (vc.imeiHub.services.{id}.checkN). */
export const IMEI_HUB_SERVICE_CHECK_KEYS: Record<ImeiHubServiceId, readonly string[]> = {
  verify: [
    'vc.imeiHub.services.verify.check1',
    'vc.imeiHub.services.verify.check2',
    'vc.imeiHub.services.verify.check3',
    'vc.imeiHub.services.verify.check4',
  ],
  passport: [
    'vc.imeiHub.services.passport.check1',
    'vc.imeiHub.services.passport.check2',
    'vc.imeiHub.services.passport.check3',
    'vc.imeiHub.services.passport.check4',
  ],
  lock: [
    'vc.imeiHub.services.lock.check1',
    'vc.imeiHub.services.lock.check2',
    'vc.imeiHub.services.lock.check3',
    'vc.imeiHub.services.lock.check4',
  ],
  carrier: [
    'vc.imeiHub.services.carrier.check1',
    'vc.imeiHub.services.carrier.check2',
    'vc.imeiHub.services.carrier.check3',
  ],
  safecheck: [
    'vc.imeiHub.services.safecheck.check1',
    'vc.imeiHub.services.safecheck.check2',
    'vc.imeiHub.services.safecheck.check3',
  ],
  business: [
    'vc.imeiHub.services.business.check1',
    'vc.imeiHub.services.business.check2',
    'vc.imeiHub.services.business.check3',
    'vc.imeiHub.services.business.check4',
  ],
  android: [
    'vc.imeiHub.services.android.check1',
    'vc.imeiHub.services.android.check2',
    'vc.imeiHub.services.android.check3',
    'vc.imeiHub.services.android.check4',
  ],
  gsx: [
    'vc.imeiHub.services.gsx.check1',
    'vc.imeiHub.services.gsx.check2',
    'vc.imeiHub.services.gsx.check3',
    'vc.imeiHub.services.gsx.check4',
  ],
  tmobile: [
    'vc.imeiHub.services.tmobile.check1',
    'vc.imeiHub.services.tmobile.check2',
    'vc.imeiHub.services.tmobile.check3',
  ],
}
